<template>
  <a-card id="components-badge-demo-dot" size="small">
    <div class="title-container">
      <a-tooltip placement="top" :title="tooltip_text">
        <div style="display: flex;">
          <span>{{ teamName }} </span>
          <CiExecuteModal ref="ciExecuteModalRef" />
          <span style="margin-left: auto; cursor: pointer;" @click="openModal">查看失败情况</span>
        </div>
      </a-tooltip>
    </div>
    <div :id="chartId" :style="{ height: height, width: width }" />
  </a-card>
</template>
<script>

import CiExecuteModal from '@/pages/data/ciexecute/components/CiExecuteModal.vue';

export default {
  components: {
    CiExecuteModal
  },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    teamName: {
      type: String,
      default: ''
    },
    success: {
      type: Number,
      default: 0
    },
    failed: {
      type: Number,
      default: 0
    },
    skip: {
      type: Number,
      default: 0
    },
    noRun: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    failGitlabUrl: {
      type: Array,
      default: () => {
        return [];
      }
    },
    chartId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tooltip_text: '涉及失败的流水线共计 ' + this.failGitlabUrl.length + ' 条',
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: params => {
            let formatter = '<b>' + '共计' + '<span style="float: right; margin-left:16px">' + params[1].value + '</b><br/>';
            formatter += params[0].name + '<span style="float: right; margin-left:16px"><b style="color: #5A6FC0;">' + params[0].value + '</b>';
            return formatter;
          }
        },
        grid: {
          top: '5%',
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            data: ['成功', '失败', '跳过', '未执行']
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            type: 'bar',
            label: {
              show: true,
              position: 'top',
              formatter: '{c}'
            },
            data: [this.success, this.failed, this.skip, this.noRun]
          },
          {
            type: 'bar',
            itemStyle: { color: 'rgba(180, 180, 180, 0.2)' }, // 背景色
            barGap: '-100%', // 使得背景系列与主数据系列重叠
            data: [this.total, this.total, this.total, this.total], // 使用最大值作为数据以填充整个图表
            animation: false // 关闭渲染动画，可提高性能
          }
        ]
      }
    };
  },
  watch: {
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/component/grid');
    require('echarts/lib/chart/bar');
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/dataZoom');
    this.myChart = echarts.init(document.getElementById(this.chartId));
    this.drawChart();
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用 */
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
    },
    openModal() {
      this.$refs.ciExecuteModalRef.showModal(this.teamName, this.failGitlabUrl);
    }
  }
};
</script>
<style>
#components-badge-demo-dot .anticon-notification {
  width: 16px;
  height: 16px;
  line-height: 16px;
  font-size: 16px;
}
</style>
